// extracted by mini-css-extract-plugin
export default {"body":"Panel_body__vJ1Ix"};